const SetupUsersHandHeldNumberActionTypes = {
  GET_HAND_HELD_NUMBER_START: 'GET_HAND_HELD_NUMBER_START',
  GET_HAND_HELD_NUMBER_SUCCESS: 'GET_HAND_HELD_NUMBER_SUCCESS',
  GET_HAND_HELD_NUMBER_FAILURE: 'GET_HAND_HELD_NUMBER_FAILURE',
};

export default SetupUsersHandHeldNumberActionTypes;
